module.exports = __webpack_public_path__ + "img/banner-agencias-mobile-min.b8fdafd3.jpg";